(function () {
  'use strict';

  function initStickyATC() {
    // Only run on product pages
    if (!document.querySelector('section[id^="MainProduct-"]')) return;

    var mainBtn = document.querySelector('section[id^="MainProduct-"] button[name="add"][type="submit"]');
    var productForm = document.querySelector('section[id^="MainProduct-"] product-form form, section[id^="MainProduct-"] form[action*="/cart/add"]');
    if (!mainBtn || !productForm) return;

    var productTitle = (document.querySelector('.product__title, h1.product__title, h1') || {}).textContent;
    productTitle = productTitle ? productTitle.trim() : '';
    var salePrice = (document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular') || {}).textContent;
    salePrice = salePrice ? salePrice.trim() : '';

    var bar = document.createElement('div');
    bar.id = 'trevena-sticky-atc';
    bar.innerHTML =
      '<div class="sticky-atc__inner">' +
        '<div class="sticky-atc__info">' +
          '<p class="sticky-atc__title">' + productTitle + '</p>' +
          '<p class="sticky-atc__price">' + salePrice + '</p>' +
        '</div>' +
        '<button class="sticky-atc__btn" type="button">Add to Cart</button>' +
        '<button class="sticky-atc__close" type="button" aria-label="Close">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);

    var stickyBtn   = bar.querySelector('.sticky-atc__btn');
    var closeBtn    = bar.querySelector('.sticky-atc__close');
    var atcVisible  = false;
    var drawerOpen  = false;
    var dismissed   = false;
    var showingConf = false;

    // TREVENA fix: don't pop the bar in instantly the moment the main button
    // scrolls out of view — wait for a short, sustained absence first. This
    // avoids it feeling like an intrusive ad that gets closed on reflex
    // during a quick scroll, which is what session recordings showed.
    var SHOW_DELAY_MS = 600;
    var showTimer = null;

    function isAnyOverlayOpen() {
      return Array.from(document.body.classList).some(function(c) {
        return c.indexOf('overflow-hidden') === 0;
      });
    }

    function reallyShouldShow() {
      return !atcVisible && !drawerOpen && !dismissed;
    }

    function updateBar() {
      if (reallyShouldShow()) {
        if (bar.style.display === 'block') return; // already shown
        if (showTimer) return; // already waiting to show
        showTimer = setTimeout(function () {
          showTimer = null;
          if (reallyShouldShow()) {
            bar.style.display = 'block';
          }
        }, SHOW_DELAY_MS);
      } else {
        if (showTimer) {
          clearTimeout(showTimer);
          showTimer = null;
        }
        bar.style.display = 'none';
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        atcVisible = entry.isIntersecting;
        updateBar();
      });
    }, { threshold: 0.5 });
    observer.observe(mainBtn);

    new MutationObserver(function () {
      var nowOpen = isAnyOverlayOpen();
      if (nowOpen !== drawerOpen) {
        drawerOpen = nowOpen;
        updateBar();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    function syncButtonState() {
      if (showingConf) return;
      stickyBtn.disabled = mainBtn.disabled;
      var span = mainBtn.querySelector('span');
      var mainBtnText = span ? span.textContent.trim() : '';
      stickyBtn.textContent = (mainBtnText && mainBtnText.toLowerCase() !== 'add to cart') ? mainBtnText : 'Add to Cart';
    }
    syncButtonState();
    new MutationObserver(syncButtonState).observe(mainBtn, { attributes: true, childList: true, subtree: true });

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      showingConf = true;
      mainBtn.click();
      stickyBtn.textContent = 'Added ✓';
      stickyBtn.style.background = '#2d6a4f';
      setTimeout(function () {
        showingConf = false;
        dismissed = true;
        updateBar();
      }, 1500);
    });

    closeBtn.addEventListener('click', function () {
      dismissed = true;
      updateBar();
    });
  }

  function initLowStockMessage() {
    // Badges are rendered server-side in Liquid (product-variant-options.liquid).
    // This only manages the dynamic stock message shown below the picker.
    var THRESHOLD = 5;
    var picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;

    var msgEl = document.getElementById('trevena-stock-msg');
    if (!msgEl) return;

    function updateStockMsg() {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (!checked) { msgEl.style.display = 'none'; return; }
      var inv = checked.getAttribute('data-inventory');
      var qty = inv !== null ? Math.max(0, parseInt(inv, 10)) : 999;
      if (qty > 0 && qty <= THRESHOLD) {
        msgEl.textContent = 'Only ' + qty + ' left in this size — order soon!';
        msgEl.style.display = 'block';
      } else {
        msgEl.style.display = 'none';
      }
    }
    updateStockMsg();
    picker.addEventListener('change', function () { setTimeout(updateStockMsg, 50); });
  }

  function init() {
    initStickyATC();
    initLowStockMessage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
